var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-box-mention-item",on:{"click":function($event){return _vm.selectMention(_vm.staff)}}},[(_vm.staff.imageUrl)?_c('div',{staticClass:"rounded-circle user_img_display img-admin-size mb-1",style:({
      backgroundImage: 'url(' + _vm.staff.imageUrl + ')'
    })}):_c('div',{staticClass:"rounded-circle img-admin img-admin-size mb-1 mr-1 mt-1",style:({
      backgroundColor: _vm.getColorFromName(_vm.staff.firstname),
      color: 'white'
    })},[_c('span',[_vm._v(_vm._s(_vm.formatName(_vm.staff.firstname)))])]),_c('p',[_vm._v(_vm._s(_vm.staff.firstname)+" "+_vm._s(_vm.staff.lastname))]),_c('p',[_vm._v(_vm._s(_vm.staff.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }